module.exports = __webpack_public_path__ + "748c0c58ff555d5be0eef2f95ec3502f.svg";